import { NotificationApi, NotificationApiTypes, NotificationPaths } from '@core/api/model/notifications/notification-api.model';
import { Notification, NotificationCategories, NotificationTypes } from '../../model/notifications/notification.model';
import { ProcedureCodes } from '@core/domain/model/procedures/procedure-codes';

export class NotificationsMapper {
  static fromApiToModel(api: NotificationApi[]): Notification[] {
    return api.map((n) => ({
      id: n.idNotificacion,
      title: n.descripcionTipo,
      type: NotificationsMapper.typeToModel(n.tipo),
      description: n.descripcion,
      date: n.fecha,
      crmCode: n.codigoCrm,
      isRead: n.leida,
      isUrgent: n.urgente,
      draftId: n.idBorrador,
      procedureTypeCode: n.tipoTramite as ProcedureCodes | null,
    }));
  }

  static typeToModel(type: NotificationApiTypes) {
    const mapper = {
      [NotificationApiTypes.TRAMITE_TYPE]: NotificationTypes.PROCEDURE,
      [NotificationApiTypes.CONTRATO_TYPE]: NotificationTypes.CONTRACT,
      [NotificationApiTypes.FACTURA_TYPE]: NotificationTypes.INVOICE,
      [NotificationApiTypes.BORRADOR_TYPE]: NotificationTypes.DRAFT,
      [NotificationApiTypes.MERCADO_TYPE]: NotificationTypes.MARKET,
      [NotificationApiTypes.ACCIONA_TYPE]: NotificationTypes.ACCIONA_ENERGY,
      [NotificationApiTypes.USUARIOS_TYPE]: NotificationTypes.USUARIOS,
      [NotificationApiTypes.ERROR_CRM_TRAMITE]: NotificationTypes.ERROR_CRM_PROCEDURE,
    };

    return mapper[type];
  }

  static categoryToPath(category: NotificationCategories) {
    const paths = {
      [NotificationCategories.ALL]: NotificationPaths.ALL,
      [NotificationCategories.URGENT]: NotificationPaths.URGENT,
      [NotificationCategories.ARCHIVED]: NotificationPaths.ARCHIVED,
      [NotificationCategories.ALERT]: NotificationPaths.ALERT,
    };

    return paths[category];
  }
}
